// src/features/quality/components/QualitySimpleTable.tsx
//
// ADR-091 Rule QC-FE-06: THIS IS A TEMPORARY STAND-IN.
// ADR-079 defines a shared DataTable component that every list page in
// this project is supposed to use. Its exact prop interface was not
// re-verified against source in this session. Rather than guess at
// ADR-079's actual API and risk silently producing something that looks
// right but doesn't match project conventions, this file provides a
// minimal, self-contained table with the same *shape* of props a
// column-based DataTable would need (columns + rows + onRowClick), so
// swapping it for the real `DataTable` later is a mechanical, low-risk
// change confined to this one file plus its two call sites
// (QualityCheckFamiliesPage, InspectionRecordsPage).
//
// TODO (blocking for final merge per ADR-091 §8): replace with the real
// `src/shared/components/DataTable` once its prop interface is confirmed.

import type { ReactNode } from "react";

export interface SimpleTableColumn<T> {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
}

export interface QualitySimpleTableProps<T> {
  columns: SimpleTableColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  onRowClick?: (row: T) => void;
  emptyMessage?: string;
}

export function QualitySimpleTable<T>({
  columns,
  rows,
  rowKey,
  onRowClick,
  emptyMessage = "موردی یافت نشد.",
}: QualitySimpleTableProps<T>) {
  if (rows.length === 0) {
    return (
      <div className="p-6 text-center text-muted">
        {emptyMessage}
      </div>
    );
  }

  return (
    <table className="w-full text-sm text-left rtl:text-right border-collapse">
      <thead>
        <tr>
          {columns.map((col) => (
            <th
              key={col.key}
              className="px-3 py-2.5 text-muted font-medium border-b border-white/10"
            >
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr
            key={rowKey(row)}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
            className={`border-b border-white/5 ${
              onRowClick ? "cursor-pointer hover:bg-white/5 transition-colors" : ""
            }`}
          >
            {columns.map((col) => (
              <td key={col.key} className="px-3 py-2.5">
                {col.render(row)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
